export const DIRECTORY = {
  STORE: 'tiendas',
  GASTRONOMY: 'gastronomia',
  SERVICE: 'servicios'
};
